import React from 'react';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

const MARKS = {
  square: { width: 8, height: 8, background: 'var(--coral)', border: ink(1.5) },
  quarter: { width: 8, height: 8, background: 'var(--gold)', border: ink(1.5), borderRadius: '100% 0 0 0' },
  dot: { width: 8, height: 8, background: 'var(--lime)', border: ink(1.5), borderRadius: '50%' },
  triangle: { width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: '9px solid var(--ink)' }
};

/**
 * Uppercase section label in Plus Jakarta Sans with an optional geometric mark. Replaces CLab
 * (size="sm").
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {'square'|'quarter'|'dot'|'triangle'} [p.mark]
 * @param {'sm'|'md'} [p.size]
 * @param {React.CSSProperties} [p.style]
 */
export function SectionLabel({ children, mark, size = 'md', style }) {
  return h('div', { className: 'gx-label', style: { display: 'inline-flex', alignItems: 'center', gap: 7, fontFamily: BODY, fontSize: size === 'sm' ? 10 : 11, fontWeight: 800, letterSpacing: 'var(--track-label)', textTransform: 'uppercase', color: 'var(--mut)', ...style } },
    mark && MARKS[mark] ? h('span', { 'aria-hidden': true, className: 'gx-mark', style: { display: 'inline-block', boxSizing: 'border-box', ...MARKS[mark] } }) : null, children);
}
